var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPandadocOutbound = function SvgPandadocOutbound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.5,
    height: 11.5,
    x: 3.25,
    y: 2.25,
    stroke: "currentColor",
    strokeWidth: 1.25,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M5.5 6h5m-5 2.25h5m-5 2.25h3.25"
  })));
};
export default SvgPandadocOutbound;